<template>
  <div>

    <modal-component
      v-model="modal.vehicle.active"
    >
      <div slot="title">{{ editVehicleMode | sentenceCase }} vehicle</div>
      <create-vehicle
        ref="vehicle"
        :in-modal="inModal"
        :vehicleID="editVehicleID"
        :create-alert="false"
        @created="closeVehicleModal($event)"
        @updated="closeVehicleModal($event)"
      ></create-vehicle>
    </modal-component>

    <ValidationObserver ref="observer">

      <div class="box">
        <p
          class="text-sm -mt-2 mb-2 text-theme-darker light:text-theme-lighter border-b border-theme-300 light:border-theme-600"
          v-if="mode === 'edit'"
        >#{{ job.id }}</p>
        <div class="flex flex-wrap items-start -mx-2">
          <div class="w-full lg:w-2/3 px-2">

            <model-select
              model="customer"
              form-name="customer"
              v-model="job.contact"
              :list.sync="customerList"
              :search-on-mount="true"
              :is-taggable="!inModal"
              @search-completed="customerSearchCompleted"
            ></model-select>

            <div class="flex flex-wrap items-end justify-between mt-4 pt-2 border-t border-theme-200 light:border-theme-600 ">
              <p class="text-xl font-bold mt-4">
                Vehicle:
                <span v-if="job.vehicle.id">#{{ job.vehicle.id }} {{ job.vehicle.make }} {{ job.vehicle.model }}</span>
              </p>

              <div class="flex flex-wrap mt-2" v-if="!inModal">
                <button
                  v-if="job.contact && job.contact.id"
                  type="button"
                  class="btn btn-purple"
                  @click="openVehicleModal('create')"
                >New vehicle</button>
                <button
                  v-if="job.vehicle && job.vehicle.id"
                  type="button"
                  class="btn btn-green ml-2"
                  @click="openVehicleModal('edit')"
                >Edit vehicle</button>
              </div>
            </div>

            <p class="text-lg text-center my-12" v-if="!vehicleList.length">
              <span v-if="job.contact && job.contact.id">No vehicles for this customer</span>
              <span v-if="!job.contact || !job.contact.id">No vehicles, please select customer first.</span>
            </p>
            <div class="flex flex-wrap -mx-2 justify-center items-center mt-4" v-else>
              <div
                v-for="(vehicle, i) in vehicleListOrdered"
                :key="'customer-vehicles-' + i"
                class="mb-4 px-2 w-full md:w-1/2 lg:w-1/3"
              >
                <div
                  class="flex items-center cursor-pointer border-4 rounded-lg"
                  :class="job.vehicle.id === vehicle.id || job.vehicle_id === vehicle.id ? 'bg-green-500 border-green-500' : 'bg-theme-200 light:bg-theme-600 border-theme-200 light:border-theme-600'"
                  @click="selectVehicle(vehicle)"
                >
                  <div class="w-1/4 rounded-l-lg bg-theme-700 self-stretch flex items-center">
                    <img
                      class="px-1 align-middle"
                      @error="onImageLoadFailure($event)"
                      v-if="'/assets/images/vehicle-logos/' + $options.filters.kebabCase(vehicle.make) + '.png'"
                      :src="'/assets/images/vehicle-logos/' + $options.filters.kebabCase(vehicle.make) + '.png'"
                    >
                  </div>
                  <div class="bg-theme-300 hover:bg-theme-800 shadow-md rounded-r-lg border-l border-theme-200 light:border-theme-600 p-2 pl-4 flex-grow">
                    <div class="leading-none">
                      <div class="flex flex-wrap justify-between">
                        <p class="text-xs font-bold">{{ vehicle.make }}</p>
                        <p class="font-bold">#{{ vehicle.id }}</p>
                      </div>
                      <p class="text-xl font-bold">{{ vehicle.model }}</p>
                    </div>

                    <div class="leading-none mt-2">
                      <p class="text-xs">Odometer:</p>
                      <p class="text-sm font-bold">
                        {{ vehicle.odometer_reading.toLocaleString() }} {{ config.speedUnits.filter(su => su.unit === vehicle.odometer_unit)[0].short }}
                      </p>
                      <div v-if="vehicle.engine_hours" class="pt-1">
                        <p class="text-xs">Engine hours:</p>
                        <p class="text-sm font-bold">
                          {{ vehicle.engine_hours }}
                        </p>
                      </div>
                    </div>

                    <div class="leading-none mt-2">
                      <p class="text-xs">Plate numbers:</p>
                      <p class="text-sm font-bold">
                        {{ vehicle.plate_numbers }}
                      </p>
                    </div>

                    <div class="leading-none text-sm mt-2 flex justify-end">
                      <p>no. of Jobs: <strong>{{ vehicle.jobs ? vehicle.jobs.length : 0 }}</strong></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="w-full lg:w-1/3 px-2">
            <model-select
              model="job-type"
              v-model="job.job_type"
              form-name="job_type"
              data-vv-as="job type"
              label="name"
              :list.sync="jobTypeList"
              :search-on-mount="true"
              :is-taggable="!inModal"
              modalSize="small"
            ></model-select>

            <div class="my-3">
              <label for="odometer-reading-at-date">
                Odometer reading at date
                <span class="text-red-500">*</span>
              </label>

              <ValidationProvider
                rules="required|integer|max_value:2147483647"
                name="odometer reading at date"
                v-slot="{ errors }"
              >
                <input
                  name="odometer_reading_at_date"
                  type="text"
                  id="odometer-reading-at-date"
                  class="form-control"
                  v-model="job.odometer_reading_at_date"
                >
                <span class="text-sm text-red-500">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <div class="my-3">
              <label for="engine-hours-at-date">
                Engine hours at date
              </label>
              <input
                name="engine_hours_at_date"
                type="text"
                id="engine-hours-at-date"
                class="form-control"
                v-model="job.engine_hours_at_date"
              >
            </div>

            <div>
              <label for="note">Note</label>
              <textarea
                name="note"
                class="form-control"
                id="note"
                rows="6"
                v-model="job.note"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="box p-0 pt-4 flex flex-wrap justify-end items-center">
          <button
            type="button"
            class="btn btn-reset"
            @click="reset"
          >
            <i class="fa-xs fas fa-undo"></i>
            <span class="ml-1">RESET</span>
          </button>
          <button
            type="button"
            class="btn btn-save"
            @click="save"
          >
            <i class="fa-xs fas fa-check"></i>
            <span class="ml-2">{{ mode === 'edit' ? 'UPDATE' : 'SAVE' }}</span>
          </button>
        </div>
      </div>

    </ValidationObserver>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const CreateVehicle = resolve => require(['@/components/pages/vehicles/Edit'], resolve)
const ModalComponent = resolve => require(['@/components/Modal'], resolve)

export default {
  name: 'job-edit',
  props: {
    jobID: {},
    createAlert: {
      type: Boolean,
      default: true,
    },
    inModal: Boolean,
  },
  components: {
    CreateVehicle,
    ModalComponent,
  },
  data() {
    return {
      mode: null,
      editID: null,
      editVehicleID: null,
      editVehicleMode: '',
      job: this.emptyJob(),
      customerList: [],
      vehicleList: [],
      jobTypeList: [],
      modal: {
        vehicle: {
          active: false,
        }
      },
      delays: {
        vehicleList: {
          d: null,
          t: 500,
        },
      }
    }
  },
  watch: {
    'job.contact.id'() {
      this.searchCustomerVehicles()
    },
    jobID() {
      this.setMode()
    }
  },
  computed: {
    vehicleListOrdered() {
      return this.vehicleList.slice().sort((a, b) => { return a.id - b.id })
    },
    ...mapGetters({
      config: 'config/config',
    })
  },
  mounted() {
    this.setMode()
  },
  methods: {
    closeVehicleModal(obj) {
      let displayName = '#' + obj.id + ' ' + obj.make + ' ' + obj.model

      this.$set(obj, 'display_name', displayName)

      // look if exists and delete if update
      let list = Object.assign([], this.vehicleList)
      for (let i in list) {
        if (list[i].id === obj.id) {
          list.splice(i, 1)
        }
      }
      list.push(obj)

      this.vehicleList = list
      this.selectVehicle(obj)
      this.editVehicleID = null

      // close modal
      this.modal.vehicle.active = false
    },
    selectVehicle(vehicle) {
      if (this.job.vehicle.id === vehicle.id || this.job.vehicle_id === vehicle.id) {
        this.job.vehicle = {}
        this.job.vehicle_id = null
        return
      }
      this.job.vehicle = vehicle
      this.job.vehicle_id = vehicle.id
    },
    onImageLoadFailure(event) {
      event.target.style.display = 'none'
    },
    openVehicleModal(mode) {
      this.editVehicleMode = mode
      if (mode === 'edit' && this.job.vehicle) {
        this.editVehicleID = this.job.vehicle.id
      } else {
        this.editVehicleID = null
      }
      this.modal.vehicle.active = true
      if (this.job.contact) {
        this.$nextTick(() => {
          const vehicle = {contact: this.job.contact}
          this.$EventBus.$emit('vehicle.create.set', vehicle)
        })
      }
    },
    setMode() {
      const name = this.$route.name.split('.')
      if (name[0] === 'job' && name[1]) {
        this.mode = name[1]
      } else {
        this.mode = 'create'
      }

      if (this.jobID) {
        this.editID = this.jobID
        this.mode = 'edit'
      } else if (this.$route.params.jobID) {
        this.editID = this.$route.params.jobID
        this.mode = 'edit'
      }

      if (this.mode === 'create') {
        this.job = this.emptyJob()
      } else {
        // get job (will do in customerSearchCompleted)
        // this.get()
      }
    },
    customerSearchCompleted() {
      if (this.mode === 'create') {
        if (this.$route.params && this.$route.params.customerID) {
          this.job.customer_id = this.$route.params.customerID
          axios.get('customers/' + this.job.customer_id)
            .then((response) => {
              this.job.contact = response.data
              this.job.contact.display_name = '#' + this.job.contact.id + ' ' + this.job.contact.first_name + ' ' + this.job.contact.last_name + (this.job.contact.company_name ? ' (' + this.job.contact.company_name + ')' : '')
              this.customerList = []
              this.customerList.push({ id: this.job.contact.id, display_name: this.job.contact.display_name})

              this.searchCustomerVehicles()
            })
        }
      } else {
        this.get()
      }
    },
    get() {
      return new Promise((resolve, reject) => {
        axios.get('jobs/' + this.editID)
          .then((response) => {
            const job = response.data

            this.job = Object.assign({}, job)

            // set customer display_name
            const customer = this.job.contact
            customer.display_name = '#' + customer.id + ' ' + customer.first_name + ' ' + customer.last_name + (customer.company_name ? ' (' + customer.company_name + ')' : '')
            this.customerList = [customer]
            // this.customerList.push(customer)
            this.job.contact = Object.assign({}, this.job.contact, customer)

            // set vehicle display_name
            const vehicle = this.job.vehicle
            vehicle.display_name = '#' + vehicle.id + ' ' + vehicle.make + ' ' + vehicle.model
            this.vehicleList = [vehicle]
            this.vehicleList.push(...this.job.contact.vehicles.map((v) => {
              v.display_name = '#' + v.id + ' ' + v.make + ' ' + v.model
              return v
            }).filter((v) => (this.vehicleList).map(o => o.id).indexOf(v.id) === -1))
            this.job.vehicle = Object.assign({}, this.job.vehicle, vehicle)


            // set job type display_name
            const jobType = this.job.job_type
            jobType.display_name = jobType.name
            this.job.job_type = Object.assign({}, this.job.job_type, jobType)

            resolve(job)
          })
          .catch((error) => reject(error))
      })
    },
    reset() {
      this.$swal.fire({
        title: 'Reset Form',
        text: 'Are you sure?',
        type: 'question',
        confirmButtonText: 'Yes',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
      })
        .then((result) => {
          if (result.value) {
            if (this.mode === 'create') {
              this.job = this.emptyJob()
            } else {
              this.get()
            }
          }
        })
    },
    async save () {
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        this.$notify({type: 'error', title: 'Form has errors'})
        return
      }
      this._save()
    },
    _save() {
      // set from vue-multiselect object
      this.job.customer_id = this.job.contact.id
      this.job.job_type_id = this.job.job_type.id

      if (this.job.vehicle.id) {
        this.job.vehicle_id = this.job.vehicle.id
      }

      // create / update
      if (this.mode === 'create') {
        axios.post('jobs', this.job)
          .then((response) => {
            const newJob = response.data
            this.$emit('created', newJob)

            if (this.createAlert) {
              this.$swal.fire({
                title: 'Done',
                text: 'Job created successfully!',
                type: 'success',
                confirmButtonText: 'Show me',
                showCancelButton: true,
                cancelButtonText: 'Create more',
              })
                .then((result) => {
                  if (result.value) {
                    this.$router.push('/job/details/' + newJob.id)
                  } else {
                    this.job = Object.assign({}, this.emptyJob())
                  }
                })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else if (this.mode === 'edit') {
        axios.put('jobs/' + this.job.id, this.job)
          .then(() => {
            this.$swal.fire({
              title: 'Done',
              text: 'Job updated successfully!',
              type: 'success',
            })
            this.$emit('updated', this.job)
            this.get()
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    searchCustomerVehicles(query) {
      if (!this.job.contact) {
        this.vehicleList = []
        return false
      }

      this.job.vehicle = {}
      if (!query || !query.length) {
        query = ''
      }
      axios.get('vehicles/search/contact/', {params: {
        contactID: this.job.contact.id,
        query,
      }})
        .then((response) => {
          this.vehicleList = response.data
        })
    },
    emptyJob() {
      return {
        customer_id: '',
        vehicle_id: '',
        note: '',
        odometer_reading_at_date: '',
        engine_hours_at_date: '',
        vehicle: {}
      }
    },
  }
}
</script>
